<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="车牌/车主名称/单位名称/联系人名称/主机名称/分组名称" style="width: 300px; margin-right: 3px;"></Input>
      <DatePicker type="daterange" :start-date="new Date()" size="small" placement="bottom-end"
                  placeholder="到费日期范围" style="width: 200px;margin-right: 3px;"
                  v-model="dateFilter"></DatePicker>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <business-note-detail-modal v-model="businessNoteDetailModal" :initValue="businessNoteInfo"
                                @on-success="onModifySuccess"></business-note-detail-modal>
    <client-info-detail-modal v-model="clientInfoDetailModal" :initValue="clientInfoDetailId"
                              @on-success="onModifySuccess"></client-info-detail-modal>
    <potential-detail-modal v-model="potentialVehicleInfoDetailModal" :initValue="potentialVehicleInfoDetailId"
                            @on-success="onModifySuccess"></potential-detail-modal>
    <combo-vehicle-info-detail-modal v-model="comboVehicleInfoDetailModal" :initValue="comboVehicleInfoDetailId"
                            @on-success="onModifySuccess"></combo-vehicle-info-detail-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <combo-vehicle-pub-info-detail-modal v-model="comboVehiclePubInfoDetailModal" :initValue="comboVehiclePubInfoDetailId"
                                         @on-success="onModifySuccess"></combo-vehicle-pub-info-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>

import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'
import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import PotentialDetailModal from '@/view/crm/components/potential-detail-modal'
import ComboVehicleInfoDetailModal from '@/view/crm/components/combo-vehicle-info-detail-modal'
import ClientInfoDetailModal from '@/view/crm/components/client-info-detail-modal'
import ComboVehiclePubInfoDetailModal from '@/view/crm/components/combo-vehicle-pub-info-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

function calRegistrationTextColor (colorid) {
  if (colorid === 1) {
    return '#ffffff'
  } else if (colorid === 2) {
    return '#ffffff'
  } else if (colorid === 3) {
    return '#ffffff'
  } else if (colorid === 4) {
    return '#000000'
  } else if (colorid === 5) {
    return '#ffffff'
  } else {
    return '#000000'
  }
}

function calRegistrationColor (colorid) {
  if (colorid === 1) {
    return '#2b85e4'
  } else if (colorid === 2) {
    return '#ff9900'
  } else if (colorid === 3) {
    return '#1c2438'
  } else if (colorid === 4) {
    return '#f8f8f9'
  } else if (colorid === 5) {
    return '#009900'
  } else {
    return '#bbbec4'
  }
}

export default {
  name: 'mycombovehicleinfobusinessnotes',
  components: {
    BusinessNoteDetailModal,
    VehicleInfoDetailModal,
    PotentialDetailModal,
    ClientInfoDetailModal,
    ComboVehicleInfoDetailModal,
    ComboVehiclePubInfoDetailModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      businessStateFilter: null,

      totalElements: 0,
      content: [],
      pageSize: 0,

      // 公开信息
      comboVehiclePubInfoDetailModal: false,
      comboVehiclePubInfoDetailId: null,

      colorLabelFilter: null,
      businessNoteTypeFilter: null,

      // 客户信息详细信息
      clientInfoDetailModal: false,
      clientInfoDetailId: null,

      // 潜在合拼车辆信息
      comboVehicleInfoDetailModal: false,
      comboVehicleInfoDetailId: null,

      // 潜在客户车辆详细信息
      potentialVehicleInfoDetailModal: false,
      potentialVehicleInfoDetailId: null,

      // 车辆信息详细信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 业务笔记详细信息
      businessNoteDetailModal: false,
      businessNoteDetailId: null,

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        clientInfoId: null,
        vehicleInfoId: null,
        potentialVehicleInfoId: null,
        comboVehicleInfoId: null,
        comboVehicleInfo: null
      },

      pubBusinessStateFilter: null,
      startDate: null,
      endDate: null,
      dateFilter: [],
      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          title: '车牌',
          resizable: true,
          tooltip: 'true',
          width: 120,
          fixed: 'left',
          render: (h, params) => {
            return h('Button', {
              props: {
                size: 'small',
                disabled: false
              },
              style: {
                backgroundColor: calRegistrationColor(params.row.comboVehicleInfo.registrationColor),
                color: calRegistrationTextColor(params.row.comboVehicleInfo.registrationColor)
              },
              on: {
                click: () => {
                  this.onDetailClick(params.row.comboVehicleInfo.id)
                }
              }
            }, params.row.comboVehicleInfo.registrationNum)
          }
        },
        {
          title: '分组/单位/车主',
          resizable: true,
          key: 'groupName',
          tooltip: 'true',
          width: 320,
          // maxWidth: 450,
          render: function (h, params) {
            return h('div', [
              h('div', params.row.comboVehicleInfo.groupName),
              h('div', params.row.comboVehicleInfo.customCompanyName),
              h('div', params.row.comboVehicleInfo.vehicleOwnerName)
            ])
          }
        },
        // {
        //   title: '车主名称',
        //   key: 'vehicleOwnerName',
        //   tooltip: 'true',
        //   minWidth: 180
        // },
        // {
        //   title: '单位名称',
        //   key: 'customCompanyName',
        //   tooltip: 'true',
        //   minWidth: 200
        // },
        {
          title: '主机名称',
          resizable: true,
          tooltip: 'true',
          width: 140,
          render: (h, params) => {
            return h('div', params.row.comboVehicleInfo.deviceName)
          }
        },
        {
          title: '到费期',
          resizable: true,
          key: 'comboVehicleInfo.serviceMatureDate',
          sortable: 'custom',
          tooltip: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.comboVehicleInfo.serviceMatureDate) {
              let d = new Date(params.row.comboVehicleInfo.serviceMatureDate)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        // {
        //   title: '跟进业务',
        //   key:'comboVehicleInfo.pubBusinessNoteUsers',
        //   tooltip: 'true',
        //   minWidth: 100,
        //   render: (h, params) => {
        //     if (params.row.comboVehicleInfo.pubBusinessNoteUsers) {
        //       let pubBusinessNoteUsers = params.row.comboVehicleInfo.pubBusinessNoteUsers
        //       let strPubBusinessNoteUsers = ''
        //       pubBusinessNoteUsers.forEach(item=>{
        //         if(item.realName){
        //           strPubBusinessNoteUsers = strPubBusinessNoteUsers + item.realName + ','
        //         }else if(item.nickName){
        //           strPubBusinessNoteUsers = strPubBusinessNoteUsers + item.nickName + ','
        //         }else if(item.name){
        //           strPubBusinessNoteUsers = strPubBusinessNoteUsers + item.name + ','
        //         }
        //       })
        //       return h('div', strPubBusinessNoteUsers)
        //     }
        //   }
        // },
        // {
        //   title: '公开状态',
        //   tooltip: 'true',
        //   minWidth: 140,
        //   filters: [
        //     {label: '待开发', value: 1},
        //     {label: '继续沟通', value: 3},
        //     {label: '沟通未果', value: 4},
        //     {label: '同意入网', value: 11}
        //   ],
        //   filterMultiple:false,
        //   filterRemote : (val) => {
        //     if(val.length > 0){
        //       this.pubBusinessStateFilter = genQueryParam('comboVehicleInfo.pubBusinessState', 'EQ', val[0])
        //     }else{
        //       this.pubBusinessStateFilter = null
        //     }
        //   },
        //   render: (h, params) => {
        //     if (params.row.comboVehicleInfo.pubBusinessState) {
        //       const state = params.row.comboVehicleInfo.pubBusinessState;
        //       if (state === 1) {
        //         return h('div', [
        //           h('Tag', {
        //             props: {
        //               type: 'dot',
        //               color: 'red'
        //             }
        //           }, '待开发')
        //         ])
        //       } else if (state === 3) {
        //         return h('div', [
        //           h('Tag', {
        //             props: {
        //               type: 'dot',
        //               color: 'blue'
        //             }
        //           }, '继续沟通')
        //         ])
        //       } else if (state === 4) {
        //         return h('div', [
        //           h('Tag', {
        //             props: {
        //               type: 'dot',
        //               color: 'black'
        //             }
        //           }, '沟通未果')
        //         ])
        //       } else if (state === 11) {
        //         return h('div', [
        //           h('Tag', {
        //             props: {
        //               type: 'dot',
        //               color: 'green'
        //             }
        //           }, '同意入网')
        //         ])
        //       }
        //     }else{
        //       return h('div', [
        //         h('Tag', {
        //           props: {
        //             type: 'dot',
        //             color: 'red'
        //           }
        //         }, '待开发')
        //       ])
        //     }
        //   }
        // },
        // {
        //   title: '公开备注',
        //   key: 'pubRemark',
        //   tooltip: 'true',
        //   minWidth: 150,
        //   render :(h, params) => {
        //     return h('div', params.row.comboVehicleInfo.pubRemark)
        //   }
        // },
        {
          title: '我的笔记状态',
          resizable: true,
          tooltip: 'true',
          width: 140,
          filters: [
            { label: '待开发', value: 1 },
            { label: '继续沟通', value: 3 },
            { label: '沟通未果', value: 4 },
            { label: '同意入网', value: 11 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              // this.pubBusinessStateFilter = genQueryParam('pubBusinessState', 'EQ', val[0])
              this.businessStateFilter = []
              val.forEach(item => {
                this.businessStateFilter.push(genQueryParam('businessState', 'EQ', item))
              })
            } else {
              this.businessStateFilter = null
            }
          },
          render: (h, params) => {
            const state = params.row.businessState
            if (state === 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '待开发')
              ])
            } else if (state === 3) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '继续沟通')
              ])
            } else if (state === 4) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'black'
                  }
                }, '沟通未果')
              ])
            } else if (state === 11) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'green'
                  }
                }, '同意入网')
              ])
            }
          }
        },
        {
          title: '颜色标签',
          resizable: true,
          key: 'colorLabel',
          ellipsis: 'true',
          width: 100,
          filters: [
            { label: '红色', value: 'ed4014' },
            { label: '橙色', value: 'ff9900' },
            { label: '黄色', value: 'ffff00' },
            { label: '绿色', value: '19be6b' },
            { label: '蓝色', value: '2db7f5' },
            { label: '紫色', value: '8a2be2' },
            { label: '无', value: 'NULL' }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              if (val[0] === 'NULL') {
                this.colorLabelFilter = genQueryParam('colorLabel', 'EQNULL', null)
              } else {
                this.colorLabelFilter = genQueryParam('colorLabel', 'LIKE', val[0])
              }
            } else {
              this.colorLabelFilter = null
            }
          },
          render: function (h, params) {
            if (params.row.colorLabel) {
              return h('div', {
                style: {
                  display: 'block',
                  width: '40px',
                  height: '20px',
                  backgroundColor: '#' + params.row.colorLabel
                }
              }, ' ')
            }
          }
        },
        {
          title: '我的笔记内容',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          key: 'content',
          minWidth: 200
        },
        {
          title: '公开笔记',
          tooltip: 'true',
          width: 200,
          render: (h, params) => {
            if (params.row.comboVehicleInfo.businessNotes) {
              let businessNotes = params.row.comboVehicleInfo.businessNotes
              let display = []
              businessNotes.forEach(item => {
                // console.log('检测')
                // console.log(item)
                let displayName = null
                if (item.user.realName) {
                  displayName = item.user.realName
                } else if (item.user.nickName) {
                  displayName = item.user.nickName
                } else if (item.user.name) {
                  displayName = item.user.name
                }

                let tag = null
                if (item.pubType === 2) {
                  tag = h('Row', [displayName])
                } else if (item.pubType === 3) {
                  let bs = null
                  const state = item.businessState
                  if (state === 1) {
                    bs = h('Tag', {
                      props: {
                        color: 'red'
                      }
                    }, '待开发')
                  } else if (state === 3) {
                    bs = h('Tag', {
                      props: {
                        color: 'blue'
                      }
                    }, '继续沟通')
                  } else if (state === 4) {
                    bs = h('Tag', {
                      props: {
                        color: 'black'
                      }
                    }, '沟通未果')
                  } else if (state === 11) {
                    bs = h('Tag', {
                      props: {
                        color: 'green'
                      }
                    }, '同意入网')
                  } else {
                    bs = h('Tag', {
                      props: {
                        color: 'red'
                      }
                    }, '未定义')
                  }
                  tag = h('Row', [displayName, bs, item.content])
                }
                // let displayItem = h('div', [tag])
                display.push(tag)
              })

              return h('div', display)
            }
          }
        },
        {
          title: '最近修改时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'updateDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.businessNoteInfo.vehicleInfoId = params.row.vehicleInfoId
                    this.businessNoteInfo.clientInfoId = params.row.clientInfoId
                    this.businessNoteInfo.potentialVehicleInfoId = params.row.potentialVehicleInfoId
                    this.businessNoteInfo.comboVehicleInfoId = params.row.comboVehicleInfoId
                    this.businessNoteInfo.id = params.row.id
                    this.businessNoteDetailId = params.row.id
                    this.businessNoteDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.comboVehiclePubInfoDetailId = params.row.comboVehicleInfo.id
                    this.comboVehiclePubInfoDetailModal = true
                  }
                }
              }, '公开信息')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'BusinessNoteServ_GetMyPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      if (this.dateFilter.length==0) {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      if (this.dateFilter[0] === '' || this.dateFilter[1] === '') {
        this.startDate = null
        this.endDate = null
        this.setPage(1)
        return
      }
      let startDate = this.dateFilter[0]
      let endDate = this.dateFilter[1]
      this.startDate = new Date(startDate).Format('yyyy-MM-dd 00:00:00')
      this.endDate = new Date(endDate).Format('yyyy-MM-dd 23:59:59')
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    filterChange () {
      this.setPage(1)
    },
    onDetailClick (id) {
      this.comboVehicleInfoDetailId = id
      this.comboVehicleInfoDetailModal = true
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let qo1 = null
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.startDate && this.endDate) {
        queryParams.push(genQueryParam('comboVehicleInfo.serviceMatureDate', 'BTDT', this.startDate, this.endDate))
      }

      if (this.colorLabelFilter) {
        queryParams.push(this.colorLabelFilter)
      }
      if (this.pubBusinessStateFilter) {
        queryParams.push(this.pubBusinessStateFilter)
      }
      if (this.businessStateFilter) {
        qo1 = this.businessStateFilter
      }

      // if(this.businessNoteTypeFilter){
      //   queryParams.push(this.businessNoteTypeFilter)
      // }
      queryParams.push(genQueryParam('comboVehicleInfoId', 'NNULL', null))

      store.dispatch('BusinessNoteServ_GetMyPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.totalElements = store.getters.get_BusinessNote_GetMyPageResult.totalElements
        this.content = store.getters.get_BusinessNote_GetMyPageResult.content
        this.pageSize = store.getters.get_BusinessNote_GetMyPageResult.size
        this.listLoadding = false
      }).catch(err => {
        this.totalElements = 0
        this.content = []
        this.pageSize = 0
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    // totalElements() {
    //   if (store.getters.get_BusinessNote_GetMyPageResult) {
    //     return store.getters.get_BusinessNote_GetMyPageResult.totalElements
    //   } else {
    //     return 0
    //   }
    // },
    // content() {
    //   if (store.getters.get_BusinessNote_GetMyPageResult) {
    //     return store.getters.get_BusinessNote_GetMyPageResult.content
    //   } else {
    //     return []
    //   }
    // },
    // pageSize() {
    //   if (store.getters.get_BusinessNote_GetMyPageResult) {
    //     return store.getters.get_BusinessNote_GetMyPageResult.size
    //   } else {
    //     return 0
    //   }
    // }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
